import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {AccessGroup, GetAccessGroupResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const ACCESSGROUP_URL = `${API_URL}/access-group`

const getAccessGroups = (
  page: number,
  limit: number,
  query?: string
): Promise<GetAccessGroupResponse> => {
  const params = {page, limit, query}

  return axios
    .get(`${ACCESSGROUP_URL}`, {params})
    .then((d: AxiosResponse<GetAccessGroupResponse>) => d.data)
}

const createAccessGroup = (accessGroup: AccessGroup): Promise<AccessGroup> => {
  const body = {
    ...accessGroup,
    departamentos: accessGroup.departamentos?.map((departamento) => departamento.id),
  }

  return axios.post(`${ACCESSGROUP_URL}`, body).then((d: AxiosResponse<AccessGroup>) => d.data)
}

const updateAccessGroup = (accessGroup: AccessGroup): Promise<AccessGroup> => {
  const body = {
    ...accessGroup,
    departamentos: accessGroup.departamentos?.map((departamento) => departamento.id),
  }

  return axios
    .patch(`${ACCESSGROUP_URL}/${accessGroup.id}`, body)
    .then((d: AxiosResponse<AccessGroup>) => d.data)
}

const deleteAccessGroup = (id: ID): Promise<AccessGroup> => {
  return axios.delete(`${ACCESSGROUP_URL}/${id}`).then((d: AxiosResponse<AccessGroup>) => d.data)
}

const getAccessGroupById = (id: ID): Promise<AccessGroup> => {
  return axios.get(`${ACCESSGROUP_URL}/${id}`).then((d: AxiosResponse<AccessGroup>) => d.data)
}

export {
  getAccessGroups,
  createAccessGroup,
  updateAccessGroup,
  deleteAccessGroup,
  getAccessGroupById,
}
